module.exports = __webpack_public_path__ + "img/114.1b0efc0b.png";